(function () {
  // Åbn/luk-tilstanden styres nu udelukkende af CSS (se pd-accordion.css: .pd-acc__panel
  // bruger grid-template-rows 0fr/1fr, samme mønster som det velfungerende
  // "zc-specs-wrap"-eksempel Carl pegede på). JS'et her sætter kun 'is-open'-klassen og
  // aria-expanded — der måles ingen højde, og der er ingen 'is-closing'-mellemtilstand,
  // ingen timer, ingen transitionend-lytter for panel-højden. Det fjerner hele den
  // klasse af race-conditions, tidligere runder kæmpede med (hurtige gen-klik der kunne
  // vise "peek"-tekst og fuld tekst samtidig): når panel og evt. peek-tekst begge kun
  // reagerer på den samme 'is-open'-klasse, i samme synkrone kald, kan de ikke komme ud
  // af trit med hinanden.
  function setOpen(item, btn, open) {
    if (btn && btn.hasAttribute('disabled')) return;
    item.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function openAll(root, open) {
    root.querySelectorAll('.pd-acc__item').forEach(function (item) {
      var btn = item.querySelector('[data-pd-acc-toggle]');
      if (btn && btn.hasAttribute('disabled')) return;
      setOpen(item, btn, open);
    });
  }

  // Er der mindst ét FOLDBART punkt (dvs. en ikke-deaktiveret toggle-knap), som stadig er
  // lukket? Punkter uden beskrivelse har en 'disabled'-knap og kan aldrig få 'is-open' —
  // de skal derfor IKKE tælle med her. Uden dette tjek ville et enkelt punkt uden
  // beskrivelse (fx et rent pause-/networking-punkt) permanent forhindre "Fold alt
  // ud/sammen"-knappen i nogensinde at rapportere "alt er åbnet", fordi det aldrig selv
  // kan blive 'is-open' — knappen ville blive hængende på "Fold sammen" og ikke kunne
  // lukke resten igen ved næste klik.
  function anyClosedFoldable(root) {
    var items = root.querySelectorAll('.pd-acc__item');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var btn = item.querySelector('[data-pd-acc-toggle]');
      if (btn && btn.hasAttribute('disabled')) continue;
      if (!item.classList.contains('is-open')) return true;
    }
    return false;
  }

  function syncToggleAllLabel(root) {
    var allBtn = root.parentElement && root.parentElement.querySelector('[data-pd-acc-toggle-all]');
    if (!allBtn) return;
    var anyClosed = anyClosedFoldable(root);
    allBtn.textContent = anyClosed ? allBtn.dataset.labelOpen : allBtn.dataset.labelClose;
  }

  function init(root) {
    if (root.dataset.pdAccInit === 'true') return;
    root.dataset.pdAccInit = 'true';
    root.addEventListener('click', function (e) {
      var btn = e.target instanceof Element ? e.target.closest('[data-pd-acc-toggle]') : null;
      if (!btn || !root.contains(btn)) return;
      var item = btn.closest('.pd-acc__item');
      if (!item || !root.contains(item) || item.parentElement.closest('[data-pd-acc-root]') !== root) return;
      e.stopPropagation();
      var open = !item.classList.contains('is-open');
      setOpen(item, btn, open);
      syncToggleAllLabel(root);
    });
  }

  function initToggleAll(btn) {
    if (btn.dataset.pdAccAllInit === 'true') return;
    btn.dataset.pdAccAllInit = 'true';
    btn.dataset.labelOpen = btn.dataset.labelOpen || btn.textContent.trim();
    btn.dataset.labelClose = btn.dataset.labelClose || 'Fold sammen';
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.pd-acc__head') || btn.parentElement;
      var root = wrap && wrap.parentElement ? wrap.parentElement.querySelector('[data-pd-acc-root]') : null;
      if (!root) return;
      var anyClosed = anyClosedFoldable(root);
      openAll(root, anyClosed);
      btn.textContent = anyClosed ? btn.dataset.labelClose : btn.dataset.labelOpen;
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pd-acc-root]').forEach(init);
    document.querySelectorAll('[data-pd-acc-toggle-all]').forEach(initToggleAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-pd-acc-root]').forEach(init);
    e.target.querySelectorAll('[data-pd-acc-toggle-all]').forEach(initToggleAll);
  });

  // Global: pills/links that should expand a target section's accordion (e.g. the "Program" quick-jump pill).
  if (!window.__pdAccExpandTargetInit) {
    window.__pdAccExpandTargetInit = true;
    document.addEventListener('click', function (e) {
      var link = e.target instanceof Element ? e.target.closest('[data-pd-expand-target]') : null;
      if (!link) return;
      var targetSection = document.getElementById(link.getAttribute('data-pd-expand-target'));
      if (!targetSection) return;
      var root = targetSection.querySelector('[data-pd-acc-root]');
      if (!root) return;
      openAll(root, true);
      syncToggleAllLabel(root);
    });
  }
})();
